import { Module } from '../../ts/Module';

/**
 * Usage:
 *
 *  //- Selected on render only
 *  input(tb-auto-select="")
 *
 *  //- Selected every time "selectMe" on the scope changes and is a truthy value
 *  input(tb-auto-select="selectMe")
 *
 */

interface IAutoSelectAttributes extends ng.IAttributes {
  tbAutoSelect: string;
}

Module.instance().directive('tbAutoSelect', <any[]>[
  '$timeout', ($timeout: ng.ITimeoutService) => {
    return {
      restrict: 'A',
      link: (scope: ng.IScope, element: JQuery, attr: IAutoSelectAttributes) => {
        // Timeout waits for element to render before selecting
        const select = () => $timeout(() => element.focus().select());

        if(attr.tbAutoSelect) {
          scope.$watch(attr.tbAutoSelect, (val: any) => {
            if(val) select();
          }, true);
        } else {
          select();
        }
      }
    };
  }
]);
